import _ from 'lodash';

export const sanitizeData = (formData, defaultStructure) => {
  const sanitized = {};

  _.forEach(defaultStructure, (defaultValue, key) => {
    if (_.has(formData, key)) {
      if (_.isObject(defaultValue) && !_.isArray(defaultValue)) {
        // Recursively sanitize nested objects
        sanitized[key] = sanitizeData(formData[key], defaultValue);
      } else if (_.isArray(defaultValue)) {
        // Handle arrays
        if (_.isArray(formData[key])) {
          if (defaultValue.length > 0 && _.isObject(defaultValue[0])) {
            // Array of objects - sanitize each object
            sanitized[key] = formData[key].map((item) =>
              sanitizeData(item, defaultValue[0])
            );
          } else {
            // Array of primitives
            sanitized[key] = formData[key].slice();
          }
        } else {
          sanitized[key] = _.cloneDeep(defaultValue);
        }
      } else {
        // Primitive values
        sanitized[key] = formData[key];
      }
    } else {
      // Field missing in formData, use default
      sanitized[key] = _.cloneDeep(defaultValue);
    }
  });

  return sanitized;
};
